import { Component, OnInit, ViewChild } from '@angular/core';
import { API_ENDPOINTS } from 'src/app/constants/api-endpoints.constants';
import { TEMPLATES } from 'src/app/constants/templates.constants';
import { BaseCardSetListComponent } from '../base-card-set-list-component/base-card-set-list.component';
import { Router } from '@angular/router';
import { DspxCardSetBaseFormComponent, SpinnerService, DialogService } from 'dspx-core';
import { QUESTION_CODES, FORM_ACTIONS } from 'src/app/constants/app-data.constants';
import { ROUTE_CONSTANTS } from 'src/app/constants/route.constants';
import { AppDataService } from 'src/app/services/app-data.service';
import { ResponseParserService } from 'src/app/services/response-parser.service';

@Component({
  selector: 'app-organisation-list',
  templateUrl: './organisation-list.component.html',
  styleUrls: ['./organisation-list.component.scss']
})
export class OrganisationListComponent extends BaseCardSetListComponent implements OnInit {

  @ViewChild(DspxCardSetBaseFormComponent)
  private set _baseForm(value: DspxCardSetBaseFormComponent) {
    this.baseForm = value
  }

  constructor(
    protected router: Router,
    protected spinnerService: SpinnerService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected appDataService: AppDataService
  ) {
    super(
      router,
      spinnerService,
      dialogService,
      responseParserService,
      appDataService,
      TEMPLATES.organisationList,
      () => API_ENDPOINTS.dashboard.getOrganisations,
      false);
  }

  ngOnInit(): void {
  }

  formLoad(event: any): void {
    this.loadGridDataOnFormLoad();
  }

  filterData(event: any): void {
    // No filters are implemented in this dashboard
  }

  dialogButtonClicked(event: any): void {
    // No dialog buttons are implemented in this dashboard
  }

  actionButtonClicked(event: any): void {
    switch (event.field.key) {
      case QUESTION_CODES.organisationListForm.organisationPlaceholder: {
        switch (event.event.type) {
          case FORM_ACTIONS.organisationListForm.new: {
            this.router.navigate(['/', ROUTE_CONSTANTS.organisation.prefix]);
            break;
          }
          case FORM_ACTIONS.organisationListForm.view:
          case FORM_ACTIONS.organisationListForm.edit: {
            this.router.navigate(['/', ROUTE_CONSTANTS.organisation.prefix, event.event.data.id]);
            break;
          }
        }
        break;
      }
    }
  }
}

